import React from 'react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { Button, Icon, Table, Header, Popup, Segment, Loader } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import { FiltersOnStyle, IconHeader } from '../Professor/ProfessorInputGrades/css';
import NewRequest from './NewRequest';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoCurrentRequestMessage = () => <p><FormattedMessage id="studentDocuments.CurrentRequestMessage" /></p>;
export default class CurrentRequests extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addRequestMode: false,
            pauseSemester:false,
            currentCancelId:0
        };
        this.activateAddRequest = this.activateAddRequest.bind(this);
        this.cancelRequest = this.cancelRequest.bind(this);
    }

    componentDidMount() {
        axios.get('students/statuses/')
            .then(res => {
                this.setState({
                    pauseSemester: res.data.pauseSemester
                });
                localStorage.setItem('studentStatuses', JSON.stringify(res.data));
            })
            .catch(err => {
                console.log('Failed to fetch student statuses.');
            });
    }

    activateAddRequest() {
        this.props.activateAddRequest(this.setState({ addRequestMode: true }));
    }

    cancelRequest(id) {
        this.props.handleLoadingButtonChange()
        this.setState({currentCancelId:id})
        axios.put(`student-documents/request-cancellation/${id}`)
            .then(res => {
                toast(<FormattedMessage id="studentDocuments.cancelRequestToast" />);
                this.props.cancelRequest();
            });
    }
    render() {
        return (
            <div>
                <Segment.Group raised >
                    <Segment clearing>
                        <Header as="h3" >
                            {!this.state.addRequestMode ?
                                <FormattedMessage id="studentDocuments.docRequest" /> : <FormattedMessage id="studentDocuments.createRequest" />}
                            <Header style={IconHeader} floated="right" >

                                <Button
                                    disabled={this.state.pauseSemester || this.state.addRequestMode || this.props.loadingButton}
                                    floated="right"
                                    icon
                                    labelPosition="right"
                                    color="blue"
                                    size="small"
                                    style={FiltersOnStyle}
                                    onClick={this.activateAddRequest}
                                >
                                    <Icon name="add" />
                                    <FormattedMessage id="studentDocuments.add" />
                                </Button>
                            </Header>
                        </Header>

                    </Segment>
                    {this.state.addRequestMode && <Segment><NewRequest
                        closeAddRequestMode={() => this.setState({ addRequestMode: false })}
                        documentTypes={this.props.documentTypes}
                        documentTemplates={this.props.documentTemplates}
                        certificateReasons={this.props.certificateReasons}
                        documentLanguages={this.props.documentLanguages}
                        sendDocumentRequest={this.props.sendDocumentRequest}
                    /></Segment>}
                    {this.props.loading ? <Segment><div style={{ paddingTop: '20px', paddingBottom: '20px' }}><Loader active inline="centered" /></div></Segment> :
                    <Segment>
                            {this.props.data.length ?
                            <Table celled selectable compact>
                                    <Table.Header>
                                    <Table.Row>
                                            <Table.HeaderCell><FormattedMessage id="studentDocuments.documentType" /></Table.HeaderCell>
                                            <Table.HeaderCell width="2"><FormattedMessage id="common.date" /></Table.HeaderCell>
                                            <Table.HeaderCell><FormattedMessage id="common.comment" /></Table.HeaderCell>
                                            <Table.HeaderCell width="3"><FormattedMessage id="studentDocuments.status" /></Table.HeaderCell>
                                            <Table.HeaderCell width="2"></Table.HeaderCell>
                                        </Table.Row>
                                </Table.Header>
                                    <Table.Body>  {this.props.data.map((el) =>
                                        (<Table.Row key={el.id}>
                                            <Table.Cell verticalAlign="middle">
                                                {el.documentTypeName}<br />{el.certificateReasonName}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" width="2">
                                                {el.date}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.comment}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" width="3" warning={el.documentStatusName === 'primljen zahtjev'}>
                                                {el.documentStatusName} <div style={{ float: 'right' }}><Icon name="arrow down" /> </div>
                                            </Table.Cell >
                                            <Table.Cell verticalAlign="middle" className="text-center" width="2">
                                                <Popup
                                                    trigger={<Button
                                                        basic
                                                        color="red"
                                                        size="small"
                                                        disabled={this.props.loadingButton}
                                                        loading={this.props.loadingButton && this.state.currentCancelId === el.id}
                                                        onClick={
                                                            () => {
                                                                this.cancelRequest(el.id);
                                                            }
                                                        }
                                                    ><FormattedMessage id="common.cancel" />
                                                    </Button>}
                                                    content={<FormattedMessage id="studentDocuments.cancelPopup" />}
                                                    hideOnScroll
                                                    position="top center"
                                                />
                                            </Table.Cell>
                                        </Table.Row>))}
                                </Table.Body>
                                </Table>
                                : <NoCurrentRequestMessage />
                            }
                            <ToastContainer hideProgressBar />
                        </Segment>}
                </Segment.Group>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentsCertificateRequest/CurrentRequests.js